import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { EventManagementService } from '@app/src/app/events/services/EventManagement/EventManagement.service';

@Injectable({ providedIn: 'root' })
export class EventManagementResolver {
  constructor(private eventManagementService: EventManagementService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const hash = route.paramMap.get('hash');
    if (hash) {
      this.eventManagementService.setEventContextHash(hash);
    }
  }
}
